import React from 'react'
import Paper from '@mui/material/Paper'
import { styled } from '@mui/material/styles'
import { Box, Chip } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { selectCurrentCountry, setCurrentCountry } from '../../../actions/discoverSlice'

const LeftItem = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#ffffff',
    padding: '16px',
    textAlign: 'center',
    color: theme.palette.text.secondary,
    borderRadius: '16px',
    borderTop: '1px solid #08082F',
}))

const countries = [
    {"code": "DZ", "name": "Algeria", "flag": "🇩🇿"},
    {"code": "BE", "name": "Belgium", "flag": "🇧🇪"},
    {"code": "FR", "name": "France", "flag": "🇫🇷"},
    {"code": "DE", "name": "Germany", "flag": "🇩🇪"},
    {"code": "JP", "name": "Japan", "flag": "🇯🇵"},
    {"code": "ES", "name": "Spain", "flag": "🇪🇸"},
    {"code": "GB", "name": "United Kingdom of Great Britain and Northern Ireland (the)", "flag": "🇬🇧"},
    {"code": "MA", "name": "Morocco", "flag": "🇲🇦"},
    {"code": "NL", "name": "Netherlands (the)", "flag": "🇳🇱"},
    {"code": "US", "name": "United States of America (the)", "flag": "🇺🇸"}
]

const CountryCard = () => {
    const dispatch = useDispatch()
    const selectedCountry = useSelector(selectCurrentCountry)

    const updateCurrentCountry = (code) => {
        dispatch(setCurrentCountry(code)) 
    }

    return (
        <LeftItem sx={{ textAlign: 'left'}}>
            <Box sx={{ overflow: 'hidden', overflowY: 'scroll', scrollbarWidth: 'none'}}>
               {
                countries.map((country, key) => <Chip 
                    key={key} 
                    label={`${country.code} - ${country.flag}`}  
                    sx={{ 
                        color: selectedCountry === country.code ? '#FFF' : '#000',
                        backgroundColor: selectedCountry === country.code ? '#7C7CCF' : '#ffffff00',
                        width: {xs: 'auto', md: '100%', lg: '100%'}
                    }} 
                    onClick={() => updateCurrentCountry(country.code)}
                    />)
               }
            </Box>
        </LeftItem>
    )
}

export default CountryCard
